import { zSchema } from "@zeal/common";

export const postNetPayDuplicateBankAccountSuppressionRequestSchema =
  zSchema.object({
    account_and_routing_number: zSchema.string(),
    workerIDs: zSchema.array(zSchema.string()),
    reason: zSchema.string(),
  });

export type TPostNetPayDuplicateBankAccountSuppressionRequest = zSchema.infer<
  typeof postNetPayDuplicateBankAccountSuppressionRequestSchema
>;

export const postNetPayDuplicateBankAccountSuppressionResponseSchema =
  zSchema.object({
    account_and_routing_number: zSchema.string(),
    created: zSchema.boolean(),
    addedWorkerIDs: zSchema.array(zSchema.string()),
    totalWorkerIDs: zSchema.array(zSchema.string()),
  });

export type TPostNetPayDuplicateBankAccountSuppressionResponse = zSchema.infer<
  typeof postNetPayDuplicateBankAccountSuppressionResponseSchema
>;
